







































































































import {
  Prop,
  Emit,
} from 'vue-property-decorator';
import { Mixins, Component } from 'vue-mixin-decorator';
import AuthConnector from '@/connector/Auth.vue';
import DialogConnector from '@/connector/Dialog.vue';
import ProfileConnector from '@/connector/Profile.vue';
import CreditTurnMixin from '@/mixins/CreditTurnMixin';
import transactionMixin from '@/mixins/transactionMixin';

@Component({
  components: {
    AuthConnector,
    DialogConnector,
    ProfileConnector,
  },
})
// eslint-disable-next-line max-len
export default class WithdrawDialog extends Mixins<CreditTurnMixin & transactionMixin>(CreditTurnMixin, transactionMixin) {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public amount: number = 0;

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  onSelectFile(file: File|null) {
    console.log(file);
    this.slip = file;
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }

  public getFormData(): any {
    return {
      amount: this.amount,
    };
  }

  public resetFormData() {
    this.amount = 0;
  }

  public async withdrawRequest(refreshCallback: Function) {
    await this.submitWithdrawRequest();
    await refreshCallback();
  }
}
